export const refreshList = (newList, actionType) => ({
  type: actionType,
  newList
});

export const requestList = actionType => ({
  type: actionType
});


// WEBPACK FOOTER //
// ./src/Actions/Action_Utils.js